export default __webpack_public_path__ + "2a28e375f957c925b47bdfe9df50a0be.otf";